// stub right now;

export default object => object
